// Action Types
export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_ALERTS = 'GET_ALERTS';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR';
export const GET_MESSAGES_CLEANUP = 'GET_MESSAGES_CLEANUP';
